<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Musical Theatre
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Musical Theatre experienced a decline in revenue by 15.7% (from $400.2m in 2018 to $337.3m in 2019) and a decline in attendance by 11.9% (from 3.9m in 2018 to 3.5m in 2019). Additionally, a decline in the average ticket price by 4.2% (from $108.85 in 2018 to $104.33 in 2019) further contributed to the decline in revenue. Top events in this category in 2019 were <em>The Book of Mormon</em>, <em>West Side Story</em>, <em>Charlie and the Chocolate Factory</em> and <em>Aladdin</em>.</p>
          <p>In 2020, the category experienced a decline in revenue (by 80.1% to $67.1m from 2019) and a decline in attendance (by 78.9% to 0.7m), due to the industry shutdown from March to November 2020. The average ticket price declined by 5.0% (to $99.07), which further contributed to the decline in revenue. Top events in this category in 2020 were <em>The Book of Mormon</em>, <em>Billy Elliot the Musical</em>, <em>Shrek the Musical</em>, <em>Chicago</em> and <em>Six the Musical</em>. </p>
          <p>Musical Theatre was the second largest category in 2019, generating 17.2% of revenue and 14.5% of attendance within the overall live performance industry. Musical Theatre was also the second largest category in revenue in 2020, generating 11.1% of total revenue and was the third largest category in attendance, generating 9.4% of total attendance.</p>
        </div>
        <div class="sixcol last">
          <p>VIC and NSW accounted for the majority share of revenue (68.6% in 2019, 71.1% in 2020) and attendance (67.2% in 2019, 68.1% in 2020) in this category. In 2019, VIC had the highest market share of revenue (35.0%) and attendance (33.2%), followed by NSW (33.6% and 33.9% market share of revenue and attendance respectively). In 2020, VIC had the highest market share of revenue (37.2%) and second highest market share of attendance (32.5%) while NSW had the second highest market share of revenue (34.0%) and highest share of attendance (35.7%). In 2019, NSW experienced a y-o-y decline of 26.2% in revenue and a 17.7% y-o-y decline in attendance, which may be explained by the movement of <em>The Book of Mormon</em> to Queensland and South Australia. In 2019, VIC experienced a y-o-y decline of 9.4% in revenue and a 12.4% y-o-y decline in attendance.</p>
          <p>COVID-19 restrictions and limited touring activity resulted in a decline in attendance and revenue in Musical Theatre. In 2020, NSW experienced a y-o-y decline of 79.9% in revenue and a 77.8% y-o-y decline in attendance. In 2020, VIC experienced a y-o-y decline of 78.9% in revenue and a 79.4% y-o-y decline in attendance.</p>
          <p>In 2019, SA experienced a significant y-o-y growth of 50.7% in revenue and a 45.5% growth in attendance from 2018. The top event in this category was <em>Aladdin</em>. In 2020, TAS witnessed a significant y-o-y growth of 90.8% in revenue and a 16.1% growth in attendance. The top event in this category was <em>Mamma Mia</em>.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Frozen the Musical</em>, Disney Theatrical Productions Australia, Photo Credit: Lisa Tomasetti</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [138.719, 178.032, 235.923, 228.855, 252.199, 214.96, 242.897, 246.792, 203.279, 193.39, 320.342, 334.869, 347.684, 416.803, 400.2, 337.338, 67.052],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [1.848, 2.46, 2.806, 3.359, 3.13, 2.458, 2.613, 2.8, 2.224, 2.085, 3.182, 3.259, 3.298, 4.042, 3.918, 3.452, 0.729],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 33.6],
            ["VIC", 35.0],
            ["QLD", 15.2],
            ["WA", 6.3],
            ["SA", 8.9],
            ["ACT", 0.9],
            ["TAS", 0.1],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 33.9],
            ["VIC", 33.2],
            ["QLD", 15.7],
            ["WA", 7.1],
            ["SA", 8.9],
            ["ACT", 0.9],
            ["TAS", 0.2],
            ["NT", 0.1]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 33.9],
            ["VIC", 37.2],
            ["QLD", 11.4],
            ["WA", 9.7],
            ["SA", 6.6],
            ["ACT", 0.3],
            ["TAS", 1.0],
            ["NT", 0.0]
          ],
          attendance: [
            ["NSW", 35.7],
            ["VIC", 32.5],
            ["QLD", 12.5],
            ["WA", 11.7],
            ["SA", 5.8],
            ["ACT", 0.5],
            ["TAS", 1.3],
            ["NT", 0.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/Jemma-Rix---Photo-by-Lisa-Tomasetti_SFW2.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
